export default __webpack_public_path__ + "static/media/Settings.ecea940f.jpg";